import {useMutation} from '@tanstack/react-query';
import {apiClient} from '../../../../lib/api-client';
import {ReportResult} from "../../../../types/ReportResult";

export const usePrintRetailPrice = (quoteID: number) => {

    const {mutateAsync, isLoading} = useMutation({
        mutationFn: async () => {
            return await apiClient.post('/estimate/print-retail-price', {
                quoteID
            }) as ReportResult;
        }
    });

    return {
        mutateAsync, isLoading
    }
}
